<ng-container *ngIf="text || longExtracts">
    <p *ngIf="text" class="{{extractsClass}} sq-text">
        <ng-container *ngIf="!hideCreatedDate">
            <span *ngIf="record.modified && !hideDate" class="extracts-date">{{record.modified |
                sqDate:dateFormat}}{{!!text ? ' - ' : ''}}</span>
        </ng-container>
        <span class="extracts-text" [innerHTML]="text"></span>
    </p>
    <ng-container *ngIf="hideCreatedDate">
        <span *ngIf="record.modified && !hideDate" class="extracts-date modified-date">{{record.modified |
            sqDate:dateFormat}}</span>
    </ng-container>
    <ng-container *ngIf="longExtracts">
        <ng-container *ngIf="!hideCreatedDate">
            <p *ngIf="record.modified && !hideDate" class="{{extractsClass}} extracts-date  sq-text">{{record.modified |
                sqDate:dateFormat}}</p>
        </ng-container>
        <ul *ngIf="longExtracts" class="{{extractsClass}} sq-text">
            <li *ngFor="let extract of longExtracts" [innerHTML]="extract"></li>
        </ul>
        <ng-container *ngIf="hideCreatedDate">
            <p *ngIf="record.modified && !hideDate" class="{{extractsClass}} extracts-date modified-date sq-text">{{record.modified |
                sqDate:dateFormat}}</p>
        </ng-container>
    </ng-container>
</ng-container>